import cn from 'classnames';
import React from 'react';

export const TermsBlock = ({
  title,
  icon,
  children,
  type = 'white',
  spacingX = true,
  spacingY = true,
  border = 'none',
  borderRadius = 'all',
  className,
  titleClassName,
}: {
  title?: React.ReactNode;
  titleClassName?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  type?: 'blue-pale' | 'white';
  spacingX?: boolean;
  spacingY?: boolean;
  border?: 'none' | 'bottom';
  borderRadius?: 'none' | 'top' | 'bottom' | 'all';
  className?: string;
}): JSX.Element => {
  return (
    <div
      className={cn('order-overview', className, {
        'bg-blue-200': type === 'blue-pale',
        'bg-white': type === 'white',
        'order-overview--border-radius': borderRadius === 'all',
        'order-overview--border-radius-top': borderRadius === 'top',
        'order-overview--border-radius-bottom': borderRadius === 'bottom',
        'order-overview--spacing-x': spacingX,
        'order-overview--spacing-y': spacingY,
        'order-overview--border-bottom border-color': border === 'bottom',
        flex: icon,
      })}
    >
      {icon && (
        <>
          <div className="order-overview--icon">{icon}</div>
          <div className="w-full">
            {title && <h6 className={titleClassName}>{title}</h6>}
            {children}
          </div>
        </>
      )}
      {!icon && (
        <>
          {title && <h6 className={titleClassName}>{title}</h6>}
          {children}
        </>
      )}
    </div>
  );
};
